<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post18-vesselmap-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post18-vesselmap-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.45573496522234;"
    data-aspect-ratio="0.456"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post18-vesselmap-xs-img"
      class="g-post18-vesselmap-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post18-vesselmap-xs.jpg);"
    ></div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:33.0175%;margin-top:-8.1px;left:33.9542%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle4">The Gulf</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.4245%;margin-top:-8.1px;left:66.2996%;margin-left:-49px;width:98px;"
    >
      <p class="g-pstyle4">Gulf of Oman</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:25.9743%;margin-top:-8.1px;right:86.5393%;width:71px;"
    >
      <p class="g-pstyle1">KUWAIT</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:30.8769%;margin-top:-15.6px;left:56.1328%;width:103px;"
    >
      <p class="g-pstyle3">Typical tanker</p>
      <p class="g-pstyle3">traffic routes</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:19.6216%;margin-top:-8.1px;right:96.8205%;width:53px;"
    >
      <p class="g-pstyle1">IRAQ</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:36.3319%;margin-top:-8.1px;left:83.8928%;margin-left:-60px;width:120px;"
    >
      <p class="g-pstyle5">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:42.5465%;margin-top:-8.1px;right:56.4509%;width:80px;"
    >
      <p class="g-pstyle1">Bahrain</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:48.4848%;margin-top:-8.1px;right:44.9716%;width:64px;"
    >
      <p class="g-pstyle1">Qatar</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:54.216%;margin-top:-15.6px;left:31.5844%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle6">Saudi</p>
      <p class="g-pstyle6">Arabia</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:58.1519%;margin-top:-8.1px;left:79.6356%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle6">UAE</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:66.0237%;margin-top:-8.1px;left:20.4948%;margin-left:-60px;width:120px;"
    >
      <p class="g-pstyle7">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:67.14%;margin-top:-8.2px;left:56.2491%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle2">Iran</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:23.7761%;margin-top:-8.2px;left:82.1135%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle2">Iran</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:88.5343%;margin-top:-8.1px;left:-2.7832%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle6">UAE</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:94.7488%;margin-top:-8.1px;left:33.5465%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle6">Oman</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:19.6964%;margin-top:-16.6px;left:23.5889%;width:138px;"
    >
      <p class="g-pstyle0">Iranian strikes</p>
      <p class="g-pstyle0">on civilian vessels</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post18-vesselmap-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.15124153498871;"
    data-aspect-ratio="1.151"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post18-vesselmap-sm-img"
      class="g-post18-vesselmap-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post18-vesselmap-sm.jpg);"
    ></div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:26.4385%;margin-top:-8.1px;left:16.6378%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle3">The Gulf</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:65.039%;margin-top:-8.1px;left:90.1072%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle3">Gulf of Oman</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:15.6313%;margin-top:-8.2px;left:63.7282%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle1">Iran</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:30.5111%;margin-top:-8.2px;left:61.6378%;margin-left:-67px;width:134px;"
    >
      <p class="g-pstyle4">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:42.0048%;margin-top:-8.1px;right:76.5257%;width:80px;"
    >
      <p class="g-pstyle5">Bahrain</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:53.0657%;margin-top:-8.1px;right:68.4714%;width:64px;"
    >
      <p class="g-pstyle5">Qatar</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:61.305%;margin-top:-15.6px;left:15.0295%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle6">Saudi</p>
      <p class="g-pstyle6">Arabia</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:22.9303%;margin-top:-15.6px;left:31.0685%;width:103px;"
    >
      <p class="g-pstyle2">Typical tanker</p>
      <p class="g-pstyle2">traffic routes</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:67.9641%;margin-top:-8.1px;left:46.4244%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle6">UAE</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:78.1221%;margin-top:-8.1px;left:70.1624%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle6">Oman</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:10.2985%;margin-top:-15.6px;left:18.1991%;width:138px;"
    >
      <p class="g-pstyle0">Iranian strikes</p>
      <p class="g-pstyle0">on civilian vessels</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post18-vesselmap-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.28155339805825;"
    data-aspect-ratio="1.282"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post18-vesselmap-md-img"
      class="g-post18-vesselmap-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post18-vesselmap-md.jpg);"
    ></div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:26.4316%;margin-top:-8.1px;left:24.0721%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle4">The Gulf</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:65.2665%;margin-top:-8.1px;left:90.2185%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle4">Gulf of Oman</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:15.59%;margin-top:-8.3px;left:66.539%;margin-left:-41.5px;width:83px;"
    >
      <p class="g-pstyle2">Iran</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:22.6371%;margin-top:-15.6px;left:37.0768%;width:103px;"
    >
      <p class="g-pstyle3">Typical tanker</p>
      <p class="g-pstyle3">traffic routes</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:10.0319%;margin-top:-15.7px;left:25.4938%;width:145px;"
    >
      <p class="g-pstyle1">Iranian strikes</p>
      <p class="g-pstyle1">on civilian vessels</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:30.7114%;margin-top:-8.2px;left:64.5866%;margin-left:-67px;width:134px;"
    >
      <p class="g-pstyle5">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:41.5691%;margin-top:-8.1px;right:70.2323%;width:80px;"
    >
      <p class="g-pstyle0">Bahrain</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:53.2196%;margin-top:-8.1px;right:62.5151%;width:64px;"
    >
      <p class="g-pstyle0">Qatar</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:61.2779%;margin-top:-15.6px;left:22.6463%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle6">Saudi</p>
      <p class="g-pstyle6">Arabia</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:14.3847%;margin-top:-8.1px;right:90.9776%;width:71px;"
    >
      <p class="g-pstyle0">KUWAIT</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:68.1711%;margin-top:-8.1px;left:50.8941%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle6">UAE</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:78.2682%;margin-top:-8.1px;left:72.2671%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle6">Oman</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:4.2876%;margin-top:-8.1px;right:94.0668%;width:53px;"
    >
      <p class="g-pstyle0">IRAQ</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post18-vesselmap-lg"
    class="g-artboard"
    style="min-width: 930px;max-width: 1199px;aspect-ratio: 1.74088090303748;"
    data-aspect-ratio="1.741"
    data-min-width="930"
    data-max-width="1199"
  >
    <div
      id="g-post18-vesselmap-lg-img"
      class="g-post18-vesselmap-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post18-vesselmap-lg.jpg);"
    ></div>
    <div
      id="g-ai3-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:30.7223%;margin-top:-9.1px;left:20.6453%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle3">The Gulf</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.4119%;margin-top:-9.1px;left:75.9114%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle3">Gulf of Oman</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:26.3233%;margin-top:-17.6px;left:31.3142%;width:109px;"
    >
      <p class="g-pstyle2">Typical tanker</p>
      <p class="g-pstyle2">traffic routes</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:17.6189%;margin-top:-9.1px;right:89.3073%;width:74px;"
    >
      <p class="g-pstyle0">KUWAIT</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:35.6048%;margin-top:-9.2px;left:55.4857%;margin-left:-70.5px;width:141px;"
    >
      <p class="g-pstyle4">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:52.2494%;margin-top:-9.1px;right:77.3391%;width:84px;"
    >
      <p class="g-pstyle0">Bahrain</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:59.3626%;margin-top:-9.1px;right:71.4811%;width:67px;"
    >
      <p class="g-pstyle0">Qatar</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:18.5859%;margin-top:-9.3px;left:55.4566%;margin-left:-41.5px;width:83px;"
    >
      <p class="g-pstyle1">Iran</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:69.3774%;margin-top:-17.6px;left:19.5242%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle5">Saudi</p>
      <p class="g-pstyle5">Arabia</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:75.5702%;margin-top:-17.7px;left:77.795%;width:153px;"
    >
      <p class="g-pstyle6">Iranian strikes</p>
      <p class="g-pstyle6">on civilian vessels</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:76.9586%;margin-top:-9.1px;left:42.6442%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle5">UAE</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:88.1901%;margin-top:-9.1px;left:60.1668%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle5">Oman</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:6.0131%;margin-top:-9.1px;right:94.2335%;width:55px;"
    >
      <p class="g-pstyle0">IRAQ</p>
    </div>
  </div>
  <!-- Artboard: xl -->
  <div
    id="g-post18-vesselmap-xl"
    class="g-artboard"
    style="min-width: 1200px;aspect-ratio: 1.93548387096774;"
    data-aspect-ratio="1.935"
    data-min-width="1200"
  >
    <div
      id="g-post18-vesselmap-xl-img"
      class="g-post18-vesselmap-xl-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post18-vesselmap-xl.jpg);"
    ></div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:42.55%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:42.55%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:42.55%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-13 10:58 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-13 10:58 -->
<!-- ai file: post18-vesselmap.ai -->
<style lang="scss">
  #g-post18-vesselmap-box {
    container-type: inline-size;
    container-name: g-post18-vesselmap-box;
  }
  #g-post18-vesselmap-box,
  #g-post18-vesselmap-box .g-artboard {
    margin: 0 auto;
  }
  #g-post18-vesselmap-box p {
    margin: 0;
  }
  #g-post18-vesselmap-box .g-aiAbs {
    position: absolute;
  }
  #g-post18-vesselmap-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post18-vesselmap-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post18-vesselmap-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post18-vesselmap-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post18-vesselmap-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post18-vesselmap-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post18-vesselmap-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post18-vesselmap-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-post18-vesselmap-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-post18-vesselmap-xl {
        display: block !important;
      }
    }
  }
  #g-post18-vesselmap-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post18-vesselmap-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(165, 15, 21);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post18-vesselmap-xs .g-pstyle0 {
    font-weight: 700;
    height: 16px;
  }
  #g-post18-vesselmap-xs .g-pstyle1 {
    font-weight: 400;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(152, 152, 152);
  }
  #g-post18-vesselmap-xs .g-pstyle2 {
    font-weight: 900;
    line-height: 15px;
    height: 15px;
    letter-spacing: 0.27em;
    font-size: 16px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-post18-vesselmap-xs .g-pstyle3 {
    font-weight: 400;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    color: rgb(64, 64, 64);
  }
  #g-post18-vesselmap-xs .g-pstyle4 {
    font-weight: 400;
    font-style: italic;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(152, 152, 152);
  }
  #g-post18-vesselmap-xs .g-pstyle5 {
    font-weight: 700;
    font-style: italic;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-post18-vesselmap-xs .g-pstyle6 {
    font-weight: 400;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(152, 152, 152);
  }
  #g-post18-vesselmap-xs .g-pstyle7 {
    font-weight: 700;
    font-style: italic;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(102, 102, 102);
  }
  #g-post18-vesselmap-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post18-vesselmap-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(165, 15, 21);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post18-vesselmap-sm .g-pstyle0 {
    font-weight: 700;
    height: 15px;
  }
  #g-post18-vesselmap-sm .g-pstyle1 {
    font-weight: 900;
    height: 15px;
    letter-spacing: 0.27em;
    font-size: 18px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-post18-vesselmap-sm .g-pstyle2 {
    font-weight: 400;
    height: 15px;
    font-size: 14px;
    color: rgb(64, 64, 64);
  }
  #g-post18-vesselmap-sm .g-pstyle3 {
    font-weight: 400;
    font-style: italic;
    height: 15px;
    text-align: center;
    color: rgb(152, 152, 152);
  }
  #g-post18-vesselmap-sm .g-pstyle4 {
    font-weight: 700;
    font-style: italic;
    height: 15px;
    font-size: 16px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-post18-vesselmap-sm .g-pstyle5 {
    font-weight: 400;
    height: 15px;
    font-size: 14px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(152, 152, 152);
  }
  #g-post18-vesselmap-sm .g-pstyle6 {
    font-weight: 400;
    height: 15px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(152, 152, 152);
  }
  #g-post18-vesselmap-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post18-vesselmap-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(165, 15, 21);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post18-vesselmap-md .g-pstyle0 {
    font-weight: 400;
    height: 15px;
    font-size: 14px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(152, 152, 152);
  }
  #g-post18-vesselmap-md .g-pstyle1 {
    font-weight: 700;
    height: 15px;
  }
  #g-post18-vesselmap-md .g-pstyle2 {
    font-weight: 900;
    height: 15px;
    letter-spacing: 0.27em;
    font-size: 19px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-post18-vesselmap-md .g-pstyle3 {
    font-weight: 400;
    height: 15px;
    font-size: 14px;
    color: rgb(64, 64, 64);
  }
  #g-post18-vesselmap-md .g-pstyle4 {
    font-weight: 400;
    font-style: italic;
    height: 15px;
    font-size: 15px;
    text-align: center;
    color: rgb(152, 152, 152);
  }
  #g-post18-vesselmap-md .g-pstyle5 {
    font-weight: 700;
    font-style: italic;
    height: 15px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-post18-vesselmap-md .g-pstyle6 {
    font-weight: 400;
    height: 15px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(152, 152, 152);
  }
  #g-post18-vesselmap-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post18-vesselmap-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 17px;
    text-align: left;
    color: rgb(165, 15, 21);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post18-vesselmap-lg .g-pstyle0 {
    font-weight: 400;
    height: 17px;
    font-size: 15px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(152, 152, 152);
  }
  #g-post18-vesselmap-lg .g-pstyle1 {
    font-weight: 900;
    height: 17px;
    letter-spacing: 0.27em;
    font-size: 19px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-post18-vesselmap-lg .g-pstyle2 {
    font-weight: 400;
    height: 17px;
    font-size: 15px;
    color: rgb(64, 64, 64);
  }
  #g-post18-vesselmap-lg .g-pstyle3 {
    font-weight: 400;
    font-style: italic;
    height: 17px;
    font-size: 15px;
    text-align: center;
    color: rgb(152, 152, 152);
  }
  #g-post18-vesselmap-lg .g-pstyle4 {
    font-weight: 700;
    font-style: italic;
    height: 17px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-post18-vesselmap-lg .g-pstyle5 {
    font-weight: 400;
    height: 17px;
    font-size: 15px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(152, 152, 152);
  }
  #g-post18-vesselmap-lg .g-pstyle6 {
    font-weight: 700;
    height: 17px;
  }
  #g-post18-vesselmap-xl {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post18-vesselmap-xl p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post18-vesselmap-xl .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-post18-vesselmap-xl .g-pstyle1 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post18-vesselmap-xl .g-pstyle2 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
</style>
